/* eslint-disable  @typescript-eslint/no-explicit-any */
import React, { useState, useEffect } from "react";
import { BreadcrumbComponent } from "../../../../common/components";
import CreateLeadCaptureFormDragDrop from "./create-lead-capture-form-drag-drop";
import CreateLeadCaptureFormPreview from "./create-lead-capture-form-preview";
import CreateLeadCapturePopupCancel from "../create-lead-capture-popups/create-lead-capture-popup-cancel/create-lead-capture-popup-cancel";
import CreateLeadCapturePopupConfirmation from "../create-lead-capture-popups/create-lead-capture-popup-confirmation/create-lead-capture-popup-confirmation";
import { initialColumns } from "./create-lead-capture-form-constant";
import { getLeadCapturePreviewBreadcrumbLink } from "./create-lead-capture-form-helper";
import { getLeadCaptureFormHtml } from "./create-lead-capture-form-html-helper";
import { createSurveysForms } from "../../../../api/surveys";
import { useLeadOwnerOptions } from "../../../../utils/getLeadOwnerOptions";
import "./create-lead-capture-form.scss";

const CreateLeadCaptureForm = (props: any) => {
  const {
    setIsShowCreateLeadSection,
    setAlertOpen,
    setAlertMessage,
    setAlertType,
    setLoading,
    fetchLeadCaptureForms,
    createLeadCaptureInitialValues,
    setCreateLeadCaptureInitialValues,
    isViewMode,
    setIsViewMode,
    isFromNewSurvey = false,
    canWrite
  } = props;

  const [columns, setColumns] = useState<any>({
    sub: {
      id: "sub",
      list: [
        {
          title: "firstName",
          id: 1,
          isRequired: true,
          isShowRequired: false,
          showClose: true,
        },
        {
          title: "lastName",
          id: 3,
          isRequired: true,
          isShowRequired: false,
          showClose: true,
        },
        {
          title: "email",
          id: 3,
          isRequired: true,
          isShowRequired: false,
          showClose: true,
        },
      ],
    },
    main: {
      id: "main",
      list: [
        { title: "primaryPhoneNumber", id: 5, isRequired: false, isShowRequired: true },
        { title: "age", id: 6, isRequired: false, isShowRequired: true },
        { title: "industry", id: 7, isRequired: false, isShowRequired: true },
        {
          title: "designation",
          id: 8,
          isRequired: false,
          isShowRequired: true,
        },
        {
          title: "interactionRate",
          id: 9,
          isRequired: false,
          isShowRequired: true,
        },{
          title: "againIn",
          id: 10,
          isRequired: false,
          isShowRequired: true,
        },{
          title: "customerSupport",
          id: 11,
          isRequired: false,
          isShowRequired: true,
        },{
          title: "product",
          id: 12,
          isRequired: false,
          isShowRequired: true,
        },{
          title: "purchasedFor",
          id: 13,
          isRequired: false,
          isShowRequired: true,
        },
        {
          title: "address",
          id: 14,
          isRequired: false,
          isShowRequired: true,
        },

        // { title: "city", id: 17, isRequired: false, isShowRequired: true },
        // { title: "state", id: 18, isRequired: false, isShowRequired: true },
        // { title: "country", id: 19, isRequired: false, isShowRequired: true },
        // { title: "zipcode", id: 20, isRequired: false, isShowRequired: true },
        // {
        //   title: "description",
        //   id: 21,
        //   isRequired: false,
        //   isShowRequired: true,
        // },
      ],
    },
  });
  const [formName, setFormName] = useState<any>("");
  const [subject, setSubject] = useState<any>("");
  const [type, setType] = useState<any>("");
  const [formLink, setFormLink] = useState<any>("");
  const [isPreview, setIsPreview] = useState(false);
  const [isCreateLeadDragDrop, setIsCreateLeadDragDrop] = useState(true);
  const [isShowCancelPopup, setIsShowCancelPopup] = useState(false);
  const [isShowConfirmationPopup, setIsShowConfirmationPopup] = useState(false);
  const [createLeadCaptureId, setCreateLeadCaptureId] = useState(null);
  const [qrCodeURL, setQRCodeURL] = useState("");
  const [breadcrumbLink, setBreadcrumbLink] = useState<any>(
    isFromNewSurvey ? 
              getLeadCapturePreviewBreadcrumbLink("create_new",
              setIsShowCreateLeadSection,
              setIsPreview,
              setIsCreateLeadDragDrop,
              setColumns,
              setIsViewMode,
              () =>{},
              formName || "" ):getLeadCapturePreviewBreadcrumbLink(
                "new",
                setIsShowCreateLeadSection,
                setIsPreview,
                setIsCreateLeadDragDrop,
                setColumns,
                setIsViewMode,
                () =>{},
                formName || ""));
  const leadOwnerFunCall = useLeadOwnerOptions()

  useEffect(() => {
    if (createLeadCaptureInitialValues) {
      setFormName(createLeadCaptureInitialValues?.form_title || "");
      setSubject(createLeadCaptureInitialValues?.form_email_subject || "");
      setType(createLeadCaptureInitialValues?.form_email_body || "");
      setFormLink(createLeadCaptureInitialValues?.form_link || "");
      setCreateLeadCaptureId(createLeadCaptureInitialValues?.id);
      setColumns({
        ...columns,
        main: {
          ...columns.main,
          list: initialColumns?.main?.list?.filter((data: any) => {
            const checkForm = createLeadCaptureInitialValues?.fields.find(
              (dataInitialValues: any) => {
                return dataInitialValues?.fieldName === data?.title;
              },
            );
            return checkForm ? false : true;
          }),
        },
        sub: {
          ...columns.sub,
          list: createLeadCaptureInitialValues?.fields.map((data: any) => {      
            return {
              ...data,
              isRequired: data?.required,
              title: data?.fieldName,
              id: data?.sequence,
              isShowRequired:
                (data?.fieldName !== "firstName" &&
                data?.fieldName !== "lastName" &&
                data?.fieldName !== "email")
                  ? true
                  : false,
              showClose:
                (data?.fieldName === "firstName" ||
                data?.fieldName === "lastName" ||
                data?.fieldName === "email")
                  ? true
                  :  false,
            };
          }),
        },
      });
          setBreadcrumbLink(getLeadCapturePreviewBreadcrumbLink(
                "edit",
                setIsShowCreateLeadSection,
                setIsPreview,
                setIsCreateLeadDragDrop,
                setColumns,
                setIsViewMode,
                () =>{},
                createLeadCaptureInitialValues?.form_title || ""
              ));
      setIsCreateLeadDragDrop(true);  

       if(isViewMode) {
          handleViewForm();
        }
    }
    return () => {
      setTimeout(() => {
        setIsViewMode(false);
        setCreateLeadCaptureInitialValues(null);
      }, 100);
    }
  }, [createLeadCaptureInitialValues]);

  const handlePreview = async () => {
    if (!formName) {
      setAlertOpen(true);
      setAlertMessage("Please enter Surveys form title");
      setAlertType("error");
    } else {
      setIsPreview(true);
      setIsCreateLeadDragDrop(false);
      setBreadcrumbLink(
        isFromNewSurvey ? 
        getLeadCapturePreviewBreadcrumbLink(
          "create_new_preview",
          setIsShowCreateLeadSection,
          setIsPreview,
          setIsCreateLeadDragDrop,
          setColumns,
          setIsViewMode,
          () =>
            setBreadcrumbLink(
              getLeadCapturePreviewBreadcrumbLink(
                "create_new",
                setIsShowCreateLeadSection,
                setIsPreview,
                setIsCreateLeadDragDrop,
                setColumns,
                setIsViewMode,
                () =>{},
                formName || ""
              ),
            ),
                formName || ""
        )
        : getLeadCapturePreviewBreadcrumbLink(
          createLeadCaptureInitialValues?.form_title ? "edit preview" : "new preview",
          setIsShowCreateLeadSection,
          setIsPreview,
          setIsCreateLeadDragDrop,
          setColumns,
          setIsViewMode,
          () =>
            setBreadcrumbLink(
              getLeadCapturePreviewBreadcrumbLink(
                createLeadCaptureInitialValues?.form_title ? "edit" : "new",
                setIsShowCreateLeadSection,
                setIsPreview,
                setIsCreateLeadDragDrop,
                setColumns,
                setIsViewMode,
                () =>{},
                formName || ""
              ),
            ),
                formName || ""
        )
      );
    }
  };

  const handleUpdateFile = async (isShareOrSave: any, formInformation: any) => {
    setLoading(true);
    try {
      const formData = new FormData();
      const leadCaptureFormDetails = {
        file: getLeadCaptureFormHtml(
          formName,
          columns?.sub?.list,
          formInformation?.id,
          leadOwnerFunCall
        ),
        fields:
          columns?.sub?.list?.map((data: any, index: any) => {
            return {
              fieldName: data?.title,
              required: data?.isRequired,
              sequence: index + 1,
            };
          }) || [],
        form_title: formName || null,
        form_email_subject: subject || "",
        form_email_body: type || "",
      };

      Object.entries(leadCaptureFormDetails).forEach(([key, value]) => {
        if (key === "fields") {
          formData.append("fields", JSON.stringify(value));
        } else {
          formData.append(key, value);
        }
      });

      const response = await createSurveysForms(
        formData,
        formInformation?.id,
      );

      if (response.data.success) {
        setCreateLeadCaptureId(formInformation?.id);
        setFormLink(response.data?.data?.form_link);
        setLoading(false);
        setAlertMessage("Surveys form details saved successfully!");
        setAlertType("success");
        setAlertOpen(true);
        if(isFromNewSurvey){
          fetchLeadCaptureForms(isShareOrSave)
        }else { 
          fetchLeadCaptureForms()
        }
        setCreateLeadCaptureInitialValues(null);
        if (isShareOrSave) {
          setQRCodeURL(response.data?.data?.qr_code_url || "");
          setIsShowConfirmationPopup(true);
        } else {
          setIsShowCreateLeadSection(false);
          setIsShowConfirmationPopup(false);
        }
      } else {
        setAlertMessage("Failed to save surveys form.");
        setAlertType("error");
        setAlertOpen(true);
        setLoading(false);
      }
    } catch (error: any) {
      setAlertMessage(
        error?.response?.data?.message ||
          "An error occurred while saving the lead.",
      );
      setAlertType("error");
      setAlertOpen(true);
      setLoading(false);
    }
  };

  const handleSavePreview = async (isShareOrSave: any, formikRef: any) => {
    formikRef?.current?.validateForm();
    if(!formikRef?.current?.isValid){
      return;
    }
    setLoading(true);
    try {
      const formData = new FormData();
      const leadCaptureFormDetails = {
        ...(createLeadCaptureId
          ? {
              file: getLeadCaptureFormHtml(
                formName,
                columns?.sub?.list,
                createLeadCaptureId,
                leadOwnerFunCall,
              ),
            }
          : {}),
        fields:
          columns?.sub?.list?.map((data: any, index: any) => {
            return {
              fieldName: data?.title,
              required: data?.isRequired,
              sequence: index + 1,
            };
          }) || [],
        form_title: formName || null,
        form_email_subject: subject || "",
        form_email_body: type || "",
      };

      Object.entries(leadCaptureFormDetails).forEach(([key, value]) => {
        if (value) {
          if (key === "fields") {
            formData.append("fields", JSON.stringify(value));
          } else {
            formData.append(key, value);
          }
        }
      });

      const response = await createSurveysForms(
        formData,
        createLeadCaptureId,
      );
      if (response.data.success) {
        if (createLeadCaptureId) {
          setLoading(false);
          setFormLink(response.data?.data?.form_link);
          setAlertMessage("Surveys form details saved successfully!");
          setAlertType("success");
          setAlertOpen(true);
          if(isFromNewSurvey){
            fetchLeadCaptureForms(isShareOrSave)
          }else { 
            fetchLeadCaptureForms()
          }
          fetchLeadCaptureForms();
          setCreateLeadCaptureInitialValues(null);
          if (isShareOrSave) {
            setQRCodeURL(response.data?.data?.qr_code_url || "");
            setIsShowConfirmationPopup(true);
          } else {
            setIsShowCreateLeadSection(false);
            setIsShowConfirmationPopup(false);
          }
        } else {
          handleUpdateFile(isShareOrSave, response.data.data);
        }
      } else {
        setAlertMessage("Failed to save Surveys form.");
        setAlertType("error");
        setAlertOpen(true);
        setLoading(false);
      }
    } catch (error: any) {
      setAlertMessage(
        error?.response?.data?.message ||
          "An error occurred while saving the lead.",
      );
      setAlertType("error");
      setAlertOpen(true);
      setLoading(false);
    }
  };

  const handleClosePreview = async () => {
    setIsShowCreateLeadSection(false);
    setIsPreview(false);
    setIsViewMode(false);
    setIsCreateLeadDragDrop(true);
    setColumns(initialColumns);
    setFormName("");
    setIsShowCancelPopup(false);
    setIsShowConfirmationPopup(false);
    setCreateLeadCaptureInitialValues(null);
    fetchLeadCaptureForms();
    setQRCodeURL("");
    setBreadcrumbLink(
      getLeadCapturePreviewBreadcrumbLink(
        createLeadCaptureInitialValues?.form_title ? "edit" : "new",
        setIsShowCreateLeadSection,
        setIsPreview,
        setIsCreateLeadDragDrop,
        setColumns,
        setIsViewMode,
        () =>{},
        formName || ""
      ),
    );
  };

  const handleViewForm = ()=>{
    setIsCreateLeadDragDrop(false);
    setIsPreview(true);
    setBreadcrumbLink(
      getLeadCapturePreviewBreadcrumbLink(
        "view",
        setIsShowCreateLeadSection,
        setIsPreview,
        setIsCreateLeadDragDrop,
        setColumns,
        setIsViewMode,
        () =>{},
        createLeadCaptureInitialValues?.form_title || ""
      ),
    );
  }

  return (
    <>
      <div className="lead-capture-wrapper">
          <BreadcrumbComponent
            breadcrumbLink={breadcrumbLink}
            showBackArrow={false}
            handleBackArrowClick={() => {
              setIsShowCreateLeadSection(false);
            }}
          />
        {isCreateLeadDragDrop ? (
          <div>
            <CreateLeadCaptureFormDragDrop
              columns={columns}
              setColumns={setColumns}
              formName={formName}
              setFormName={setFormName}
              handlePreview={handlePreview}
              initialColumns={initialColumns}
              isEdit={!!createLeadCaptureInitialValues}
              canWrite={canWrite}
              isFromNewSurvey={isFromNewSurvey}
            />
          </div>
        ) : (
          ""
        )}
        {isPreview ? (
          <div>
            <CreateLeadCaptureFormPreview
              columns={columns}
              setColumns={setColumns}
              formName={formName}
              setFormName={setFormName}
              handlePreview={handlePreview}
              initialColumns={initialColumns}
              setIsShowCancelPopup={setIsShowCancelPopup}
              handleSavePreview={handleSavePreview}
              setIsShowConfirmationPopup={setIsShowConfirmationPopup}
              subject={subject}
              setSubject={setSubject}
              type={type}
              setType={setType}
              createLeadCaptureId={createLeadCaptureId}
              isViewMode={isViewMode}
              handleClosePreview ={handleClosePreview}
            />
          </div>
        ) : (
          ""
        )}
        {isShowCancelPopup ? (
          <div>
            <CreateLeadCapturePopupCancel
              setIsShowCancelPopup={setIsShowCancelPopup}
              isShowCancelPopup={isShowCancelPopup}
              handleClosePreview={handleClosePreview}
            />
          </div>
        ) : (
          ""
        )}
        {isShowConfirmationPopup ? (
          <div>
            <CreateLeadCapturePopupConfirmation
              isShowConfirmationPopup={isShowConfirmationPopup}
              setIsShowConfirmationPopup={setIsShowConfirmationPopup}
              handleSavePreview={handleSavePreview}
              createLeadCaptureId={createLeadCaptureId}
              formLink={formLink}
              setAlertMessage={setAlertMessage}
              setAlertType={setAlertType}
              setAlertOpen={setAlertOpen}
              setLoading={setLoading}
              handleClosePreview={handleClosePreview}
              qrCodeUrl={qrCodeURL}
              formName={formName}
            />
          </div>
        ) : (
          ""
        )}
      </div>
    </>
  );
};

export default CreateLeadCaptureForm;
